export const loginUrl = 'http://localhost:3001'
export const logoutUrl = '/'
export const SIDER_TITLE = ""
export const API_URL = "https://localhost:8080"
export const ACCOUNT_ID = "9840c18a-6071-46a1-847a-1d80f574b9cf"
export const CLIENT_ID = "7f374ba5-2883-4939-82fb-0cbbb77ef514"
